import React, { Component } from 'react';
import { Badge, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';

import { AppHeaderDropdown, AppSidebarToggler } from '@coreui/react';
import Avatar from '../../Components/Common/Avatar';
import OssLogo from '../../Components/Common/OssLogo';

const propTypes = {
    children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {
    render() {
        // eslint-disable-next-line
        const { children, ...attributes } = this.props;
        const userEmail = JSON.parse(localStorage.getItem('user_email'));
        const userName = JSON.parse(localStorage.getItem('user_name'));
        const userAvatar = JSON.parse(localStorage.getItem('user_avatar'));
        return (
            <React.Fragment>
                <AppSidebarToggler className="d-lg-none" display="md" mobile />
                    <a className="navbar-brand" href="#/" style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <OssLogo size={24} id="hdr" ssColor="#0f172a" />
                    </a>
                <AppSidebarToggler className="d-md-down-none" display="lg" />
                <Nav className="ml-auto" navbar>
                    <AppHeaderDropdown direction="down">
                        <DropdownToggle nav>
                            <Avatar src={userAvatar} name={userName} email={userEmail} size={40} />
                        </DropdownToggle>
                        <DropdownMenu right style={{ right: 'auto' }}>
                            <DropdownItem header tag="div" className="text-center"><strong>Configuración</strong></DropdownItem>
                            <DropdownItem onClick={this.props.onMyAccountClick}>
                                <i className="fa fa-user"></i> Mi cuenta
                            </DropdownItem>
                            {/* <DropdownItem><i className="fa fa-shield"></i> Bloquear Pantalla</DropdownItem> */}
                            <DropdownItem onClick={this.props.logout}><i className="fa fa-lock"></i> Cerrar Sesión</DropdownItem>
                        </DropdownMenu>
                    </AppHeaderDropdown>
                </Nav>
                {/* <AppAsideToggler className="d-md-down-none" /> */}
                {/*<AppAsideToggler className="d-lg-none" mobile />*/}
        </React.Fragment>
        );
    }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;



// WEBPACK FOOTER //
// ./src/Containers/DefaultLayout/DefaultHeader.js